// @ts-nocheck
import { tsValueToJsonValueFns, jsonValueToTsValueFns, } from "../../runtime/json/scalar";
import { default as serialize, } from "../../runtime/wire/serialize";
import { tsValueToWireValueFns, wireValueToTsValueFns, } from "../../runtime/wire/scalar";
import { default as deserialize, } from "../../runtime/wire/deserialize";
export function getDefaultValue() {
    return {
        amount: "",
        precision: "0",
        scale: "0",
    };
}
export function createValue(partialValue) {
    return {
        ...getDefaultValue(),
        ...partialValue,
    };
}
export function encodeJson(value) {
    const result = {};
    if (value.amount !== undefined)
        result.amount = tsValueToJsonValueFns.string(value.amount);
    if (value.precision !== undefined)
        result.precision = tsValueToJsonValueFns.int64(value.precision);
    if (value.scale !== undefined)
        result.scale = tsValueToJsonValueFns.int64(value.scale);
    return result;
}
export function decodeJson(value) {
    const result = getDefaultValue();
    if (value.amount !== undefined)
        result.amount = jsonValueToTsValueFns.string(value.amount);
    if (value.precision !== undefined)
        result.precision = jsonValueToTsValueFns.int64(value.precision);
    if (value.scale !== undefined)
        result.scale = jsonValueToTsValueFns.int64(value.scale);
    return result;
}
export function encodeBinary(value) {
    const result = [];
    if (value.amount !== undefined) {
        const tsValue = value.amount;
        result.push([1, tsValueToWireValueFns.string(tsValue)]);
    }
    if (value.precision !== undefined) {
        const tsValue = value.precision;
        result.push([2, tsValueToWireValueFns.int64(tsValue)]);
    }
    if (value.scale !== undefined) {
        const tsValue = value.scale;
        result.push([3, tsValueToWireValueFns.int64(tsValue)]);
    }
    return serialize(result);
}
export function decodeBinary(binary) {
    const result = getDefaultValue();
    const wireMessage = deserialize(binary);
    const wireFields = new Map(wireMessage);
    field: {
        const wireValue = wireFields.get(1);
        if (wireValue === undefined)
            break field;
        const value = wireValueToTsValueFns.string(wireValue);
        if (value === undefined)
            break field;
        result.amount = value;
    }
    field: {
        const wireValue = wireFields.get(2);
        if (wireValue === undefined)
            break field;
        const value = wireValueToTsValueFns.int64(wireValue);
        if (value === undefined)
            break field;
        result.precision = value;
    }
    field: {
        const wireValue = wireFields.get(3);
        if (wireValue === undefined)
            break field;
        const value = wireValueToTsValueFns.int64(wireValue);
        if (value === undefined)
            break field;
        result.scale = value;
    }
    return result;
}
